import * as React from 'react';
import { createSelector } from '@reduxjs/toolkit';
import { Box/* ,DemoPaper */,Paper, Button,Stack,Snackbar, Container, CssBaseline, GridLegacy, TextField, Typography, Checkbox,Link, CircularProgress, Card, CardContent, CardActionArea, Chip, Divider } from '@mui/material';
// import aspectRatio from '@mui'
import PlaylistAddIcon from '@mui/icons-material/PlaylistAdd';
import ManageSearchIcon from '@mui/icons-material/ManageSearch'; 
import FamilyRestroomIcon from '@mui/icons-material/FamilyRestroom';
import Diversity2Icon from '@mui/icons-material/Diversity2';
import PostAddIcon from '@mui/icons-material/PostAdd';
import DashboardIcon from '@mui/icons-material/Dashboard';
import FolderIcon from '@mui/icons-material/Folder';
import StorageIcon from '@mui/icons-material/Storage';
import { styled } from '@mui/material/styles';
import { AppGlobalContext } from '../../../App';
import TEXT from './text';
import { useSelector} from 'react-redux';
import DbGroupDashboard from '../DbGroupDashboard/DbGroupDashboard';
const StyledPaper = styled(Paper)(({ theme }) => ({
  width: "auto",
//   height: "",
//   aspectRatio: 
  
  padding: theme.spacing(2),
  ...theme.typography.body2,
  textAlign: 'center',
  backgroundColor: theme.palette.secondary.main,
}));

export default function Home_page_body() {
    const language = useSelector((state) => state.App_Settings.language);
    const userMetadata = useSelector(state => state.UserMetaData);
    const AppGlobalContxt = React.useContext(AppGlobalContext);
    
    const [loadingGroups, setLoadingGroups] = React.useState(true);
    const [dbGroups, setDbGroups] = React.useState([]);
    
    // Load database groups on mount
    React.useEffect(() => {
        loadDatabaseGroups();
    }, []);
    
    const loadDatabaseGroups = async () => {
        setLoadingGroups(true);
        try {
            const response = await fetch(
                window.devMode ? 'http://localhost:80/get_accessible_items' : '/get_accessible_items',
                {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ email: userMetadata.email })
                }
            );

            const data = await response.json();
            
            // Handle different response formats
            let groupsData = [];
            if (data.groups) {
                groupsData = data.groups;
            } else if (data.dbgroups) {
                groupsData = data.dbgroups;
            } else if (data.accessible_groups) {
                groupsData = data.accessible_groups;
            }
            
            // Format groups
            const formattedGroups = groupsData.map(group => ({
                group_id: group.group_id || group.id || group.groupId,
                group_name: group.group_name || group.name || group.groupName || `Group ${group.group_id || group.id}`,
                version: group.version || 1,
                database_count: group.database_count || group.databases?.length || 0
            }));
            
            setDbGroups(formattedGroups);
        } catch (err) {
            console.error('[Home] Error loading groups:', err);
        } finally {
            setLoadingGroups(false);
        }
    };
    
    return (                                  /* as the drawer size is 20px on the left side */
        <Box component={"main"} sx={{ marginLeft:"0px", marginRight:"20px", width: "auto" }}>
            <Typography variant="h6" sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
                <DashboardIcon />
                {TEXT.Dashboard?.[language] || 'Dashboard'}
            </Typography>
            
            {/* Database Groups Dashboards */}
            {loadingGroups ? (
                <Paper sx={{ p: 3, textAlign: 'center', mb: 3 }}>
                    <CircularProgress size={30} />
                    <Typography variant="body2" sx={{ mt: 2 }}>
                        {TEXT.Loading?.[language] || 'Loading...'}
                    </Typography>
                </Paper>
            ) : dbGroups.length > 0 ? (
                <Box sx={{ mb: 4 }}>
                    {dbGroups.map((group, index) => (
                        <Box key={group.group_id} sx={{ mb: 4 }}>
                            <DbGroupDashboard
                                groupId={group.group_id}
                                groupName={group.group_name}
                                onBack={null}
                            />
                            {index < dbGroups.length - 1 && (
                                <Divider sx={{ my: 4 }} />
                            )}
                        </Box>
                    ))}
                </Box>
            ) : null}
            
            {/* Quick Actions */}
            <GridLegacy component={"section"} container spacing={2} sx={{ mt: 2 }}>
                <GridLegacy item xs={12}>
                    <Typography variant="h6" sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
                        <DashboardIcon />
                        {TEXT.QuickActions?.[language] || 'Quick Actions'}
                    </Typography>
                </GridLegacy>
            <GridLegacy item xs={6}>
                <StyledPaper elevation={3} onClick={() => {AppGlobalContxt.Body.setPageName("Registration")}}>
                    <PlaylistAddIcon fontSize="large" />
                    <br />
                    {TEXT.Registration[language]}
                </StyledPaper>
            </GridLegacy>
            <GridLegacy item xs={6}>
                <StyledPaper elevation={3} onClick={() => {AppGlobalContxt.Body.setPageName("Registed")}}>
                    <ManageSearchIcon fontSize="large" />
                    <br />
                    {TEXT.Registed[language]}
                </StyledPaper>
            </GridLegacy>
            <GridLegacy item xs={6}>
                <StyledPaper elevation={3} onClick={() => {AppGlobalContxt.Body.setPageName("Session")}}>
                    <FamilyRestroomIcon fontSize="large" />
                    <br />
                    {TEXT.Sessions[language]}
                </StyledPaper>
            </GridLegacy>
            <GridLegacy item xs={6}>
                <StyledPaper elevation={3} onClick={() => {AppGlobalContxt.Body.setPageName("Volanteering")}}>
                    <Diversity2Icon fontSize="large" />
                    <br />
                    {TEXT.Volanteering[language]}
                </StyledPaper>
            </GridLegacy>
            <GridLegacy item xs={6}>
                <StyledPaper elevation={3} onClick={() => {AppGlobalContxt.Body.setPageName("CreateDbGroup")}}>
                    <PostAddIcon fontSize="large" />
                    <br />
                    {TEXT.CreateDbGroup[language]}
                </StyledPaper>
            </GridLegacy>
            <GridLegacy item xs={6}>
                <StyledPaper elevation={3} onClick={() => {AppGlobalContxt.Body.setPageName("CreateDb")}}>
                    <PostAddIcon fontSize="large" />
                    <br />
                    {TEXT.CreateDB[language]}
                </StyledPaper>
            </GridLegacy>
            <GridLegacy item xs={6}>
                <StyledPaper elevation={3} onClick={() => {AppGlobalContxt.Body.setPageName("DbBrowser")}}>
                    <ManageSearchIcon fontSize="large" />
                    <br />
                    {TEXT.DbBrowser[language]}
                </StyledPaper>
            </GridLegacy>
            <GridLegacy item xs={6}>
                <StyledPaper elevation={3} onClick={() => {AppGlobalContxt.Body.setPageName("Dashboard")}}>
                    <DashboardIcon fontSize="large" />
                    <br />
                    {TEXT.Dashboard[language]}
                </StyledPaper>
            </GridLegacy>
            </GridLegacy>
        </Box>
    );
}